export default "__VITE_ASSET__BwVa4$Pp__"